import { Injector, OnInit } from '@angular/core';
import { DataGridTemplate } from '../../../../shared/data-grid/data-grid.template';
import { FormGroup } from '@angular/forms';
import { FormDialogTemplate } from '../../../../shared/form-dialog/form-dialog.template';
import { BehaviorSubject, Subject, Observable } from 'rxjs';
import { RowClassArgs } from '@progress/kendo-angular-grid';
import { UploadService } from './upload-service';

export class InvalidColumnsGrid extends DataGridTemplate {
  private readonly uploadService: UploadService;
  editForm: FormGroup;
  formDialog: FormDialogTemplate;
  dialogTitle: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
  clearEnabled: boolean;

  constructor(private readonly injector: Injector) {
    super();
    this.controls.add = false;
    this.controls.excel = false;
    this.controls.delete = false;
    this.controls.edit = false;
    this.pageable = false;
    this.resizable = true;
    this.uploadService = injector.get(UploadService);
  }

  read(opts: any): Promise<any> {
    const response = [{ index: 0, columnName: 'PartName', errorMessage: 'Error: No input entered for this record. Field was empty or contained only whitespace characters' }]
    let message = "";
    opts.parentEditDataItem.InvalidColumns.forEach(element => {
      message += element.ErrorMessage + " ";
    });
    response[0].errorMessage = message;
    return Promise.resolve(response);
  }

  create(parentEditDataItem: any): void { }

  edit(dataItem: any): void { }

  save(dataItem: any, isNew: boolean): Promise<any> {
    return Promise.resolve([]);
  }

  delete(dataItem: any): Promise<any> {
    return Promise.resolve([]);
  }

  /**
   * 
   * @param context 
   * callback function to add 'highlight' html classs to a row
   */
  rowCallback = (context: RowClassArgs) => {
    const invalid = context.dataItem.ResponseStatus === 'Invalid';
    return {
      highlight: invalid,
    };
  }

  handleApply = () => {
    this.uploadService.showApplyReport.next(true);
  }

  onSelectionChange = (e) => {
    const dataItem = e.selectedRows[0].dataItem;

    if (dataItem.ResponseStatus === 'Invalid') {
      this.uploadService.showInvalidColumns.next(true);
    }
  }

  showGridDetailCondition = (dataItem: any) => {
    return dataItem.ResponseStatus === 'Invalid';
  };


  columns: any[] = [
    {
      field: "errorMessage",
      title: "Error Message",
      width: '*',
    },
  ]
}
